import { render, staticRenderFns } from "./DefinitionsTab.vue?vue&type=template&id=9ba2a1d0&scoped=true&"
import script from "./DefinitionsTab.vue?vue&type=script&lang=js&"
export * from "./DefinitionsTab.vue?vue&type=script&lang=js&"
import style0 from "./DefinitionsTab.vue?vue&type=style&index=0&id=9ba2a1d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba2a1d0",
  null
  
)

export default component.exports